import type { UserBrief } from "../types/api";

export const PERMISSIONS = {
  panelAccess: "panel.access",
  dashboardView: "dashboard.view",
  productsView: "catalog.products.view",
  productsManage: "catalog.products.manage",
  taxonomyManage: "catalog.taxonomy.manage",
  inventoryManage: "inventory.manage",
  ordersView: "orders.view",
  ordersManage: "orders.manage",
  customersView: "customers.view",
  customersManage: "customers.manage",
  financeView: "finance.view",
  shippingManage: "shipping.manage",
  reviewsManage: "reviews.manage",
  contentManage: "content.manage",
  marketingManage: "marketing.manage",
  seoManage: "seo.manage",
  supportManage: "support.manage",
  settingsManage: "settings.manage",
  staffManage: "staff.manage",
  reportsView: "reports.view",
  auditView: "audit.view",
} as const;

export type PermissionKey = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export const STAFF_ROLES = [
  "SuperAdmin", "Admin", "StoreManager", "ProductManager", "InventoryManager", "OrderManager",
  "Finance", "Shipping", "CustomerSupport", "ContentManager", "MarketingManager", "SeoManager",
  "Analyst", "Auditor",
] as const;

export const ROLE_LABELS: Record<string, string> = {
  SuperAdmin: "مالک سیستم",
  Admin: "مدیر فروشگاه",
  StoreManager: "مدیر فروش",
  ProductManager: "مدیر محصولات",
  InventoryManager: "انباردار",
  OrderManager: "مسئول سفارشات",
  Finance: "حسابداری",
  Shipping: "مسئول ارسال",
  CustomerSupport: "پشتیبانی مشتریان",
  ContentManager: "مدیر محتوا",
  MarketingManager: "مدیر بازاریابی",
  SeoManager: "مدیر SEO",
  Analyst: "گزارش‌گیر",
  Auditor: "ناظر",
  Customer: "مشتری",
  VIP: "مشتری ویژه",
  User: "کاربر معمولی",
};

export function isStaffRole(role: string): boolean {
  return STAFF_ROLES.some((item) => item.toLowerCase() === role.toLowerCase());
}

export function hasPermission(user: UserBrief | null | undefined, permission: PermissionKey): boolean {
  if (!user) return false;
  if (user.roles.some((role) => role.toLowerCase() === "superadmin")) return true;
  return (user.permissions ?? []).some((item) => item.toLowerCase() === permission.toLowerCase());
}

export function hasPanelAccess(user: UserBrief | null | undefined): boolean {
  return hasPermission(user, PERMISSIONS.panelAccess);
}

export function primaryRoleLabel(user: UserBrief | null | undefined): string {
  const role = user?.roles.find((item) => isStaffRole(item));
  return role ? ROLE_LABELS[role] ?? role : "کاربر";
}
